import React from 'react';
import '../styles/distribution-chart.css';

const BUCKET_FALLBACK = Array.from({ length: 10 }, (_, idx) => ({
  bucket_index: idx,
  lower_bound: idx * 10,
  upper_bound: idx === 9 ? 100 : idx * 10 + 9,
  company_count: 0,
  company_share: 0,
}));

const getBucketIndex = (score) => {
  if (score == null || Number.isNaN(Number(score))) return null;
  return Math.max(0, Math.min(9, Math.floor(Number(score) / 10)));
};

const getTopPercentLabel = (percentile) => {
  if (percentile == null || Number.isNaN(Number(percentile))) return 'N/A';
  const topPercent = Math.max(1, 101 - Math.round(Number(percentile)));
  return `Top ${topPercent}%`;
};

function ScoreDistributionChart({
  title,
  infoText,
  score,
  percentile,
  buckets,
  accentColor = '#a0ffc3',
  showAxisLabels = false,
}) {
  const resolvedBuckets = Array.isArray(buckets) && buckets.length > 0 ? buckets : BUCKET_FALLBACK;
  const highlightedBucketIndex = getBucketIndex(score);
  const maxCount = Math.max(1, ...resolvedBuckets.map((bucket) => Number(bucket.company_count || 0)));

  return (
    <article className="score-distribution-card">
      <div className="score-distribution-card__header">
        <div className="score-distribution-card__title-wrap">
          <h3>{title}</h3>
          {infoText && (
            <span className="score-distribution-card__info">
              <button
                type="button"
                className="score-distribution-card__info-button"
                aria-label={`${title} information`}
              >
                ?
              </button>
              <span className="score-distribution-card__tooltip" role="tooltip">
                {infoText}
              </span>
            </span>
          )}
        </div>
        <span className="score-distribution-card__top-label">{getTopPercentLabel(percentile)}</span>
      </div>

      <div className="score-distribution-card__chart" role="img" aria-label={`${title} distribution chart`}>
        {resolvedBuckets.map((bucket) => {
          const count = Number(bucket.company_count || 0);
          const heightPercent = Math.max(8, Math.round((count / maxCount) * 100));
          const isHighlighted = highlightedBucketIndex === Number(bucket.bucket_index);

          return (
            <div key={`${title}-${bucket.bucket_index}`} className="score-distribution-card__bar-slot">
              <div
                className={`score-distribution-card__bar${isHighlighted ? ' is-highlighted' : ''}`}
                style={{
                  height: `${heightPercent}%`,
                  '--distribution-accent': accentColor,
                }}
                title={`${bucket.lower_bound}-${bucket.upper_bound}: ${count} companies`}
                aria-label={`${bucket.lower_bound}-${bucket.upper_bound}, ${count} companies`}
              />
              {showAxisLabels && (
                <span className="score-distribution-card__bar-label">{bucket.lower_bound}</span>
              )}
            </div>
          );
        })}
      </div>
    </article>
  );
}

export default ScoreDistributionChart;
